/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { EnergyConsumption } from "./EnergyConsumption";
import {
    EnergyConsumptionFromJSON,
    EnergyConsumptionFromJSONTyped,
    EnergyConsumptionToJSON,
} from "./EnergyConsumption";

/**
 *
 * @export
 * @interface EnergyConsumptionResponse
 */
export interface EnergyConsumptionResponse {
    /**
     *
     * @type {Array<EnergyConsumption>}
     * @memberof EnergyConsumptionResponse
     */
    items?: Array<EnergyConsumption>;
    /**
     * Currently always 'Australia/NEM_Time'. NEM Time is always UTC+10, with no daylight savings
     * @type {string}
     * @memberof EnergyConsumptionResponse
     */
    siteTimeZone?: string;
}

/**
 * Check if a given object implements the EnergyConsumptionResponse interface.
 */
export function instanceOfEnergyConsumptionResponse(
    value: object,
): value is EnergyConsumptionResponse {
    return true;
}

export function EnergyConsumptionResponseFromJSON(
    json: any,
): EnergyConsumptionResponse {
    return EnergyConsumptionResponseFromJSONTyped(json, false);
}

export function EnergyConsumptionResponseFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): EnergyConsumptionResponse {
    if (json == null) {
        return json;
    }
    return {
        items:
            json["items"] == null
                ? undefined
                : (json["items"] as Array<any>).map(EnergyConsumptionFromJSON),
        siteTimeZone:
            json["siteTimeZone"] == null ? undefined : json["siteTimeZone"],
    };
}

export function EnergyConsumptionResponseToJSON(
    value?: EnergyConsumptionResponse | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        items:
            value["items"] == null
                ? undefined
                : (value["items"] as Array<any>).map(EnergyConsumptionToJSON),
        siteTimeZone: value["siteTimeZone"],
    };
}
